<script>
    export let followerCount;
</script>

<div class="stats">
    <div class="count">
        <span>Follower</span>
        <span class="larger">{followerCount?.total??0}</span>
    </div>
    <div class="count">
        <span>Mit Pushnachricht</span>
        <span class="larger">{followerCount?.notificationEnabled??0}</span>
    </div>
</div>
    
<style>
    .stats {
        display: flex;
        gap: 1rem;
    }

    .count {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        border: 1px solid #eee;
        border-radius: 0.5rem;
        padding: 0.75rem 1.5rem;
    }

    .larger {
        font-size: 1.25rem;
        font-weight: bold;
        line-height: 1;
    }
</style>